import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './ModalFooter.module.scss';

export const ModalFooter = ({ className, children }: Props) => (
    <div className={classNames(className, styles.default)}>
        {children}
    </div>
);

type Props = PropsWithChildren<{ className?: string }>;